import React, { Component } from 'react';
import DatePicker from 'react-date-picker';
import moment from 'moment';
import { connect } from 'react-redux';
import { toNumber, get } from 'lodash';
import Select from 'react-select';

import { storeListDMAForSelect, storeSearchMonth, storeSearchYear, storeSearchDMA } from '../../../../redux/general/action';
import './wrapper-searchbox-water-balance-table.style.css';

export class WrapperSearchBoxWBL extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dateSearch: new Date(this.props.yearSearchFromMap, toNumber(this.props.monthSearchFromMap) - 1, 1),
            monthSearch: toNumber(this.props.monthSearchFromMap),
            yearSearch: toNumber(this.props.yearSearchFromMap),
            dmaID: (this.props.dmaidSearchFromMap !== '') ? this.props.dmaidSearchFromMap : ''
        }
    }

    handleChange = (selectedOption) => {
        if (selectedOption) {
            this.props.storeSearchDMA(selectedOption.value)
        } else {
            this.props.storeSearchDMA('')
        }
        
    }

    onChange = dateInput => {
        if (dateInput) {
            const monthSearch = toNumber(moment(dateInput).format('MM'));
            const yearSearch = toNumber(moment(dateInput).format('yyyy'));
            this.props.storeSearchMonth(monthSearch);
            this.props.storeSearchYear(yearSearch);
        } else {
            const monthSearch = toNumber(moment().format('MM'));
            const yearSearch = toNumber(moment().format('yyyy'));
            this.props.storeSearchMonth(monthSearch);
            this.props.storeSearchYear(yearSearch);
        }
    }

    searchNow = () => {
        this.props.searchFromParent(this.props.searchMonth, this.props.searchYear, this.props.searchDMA);
    }

    render() {
        const options = this.props.listDMAForSelect;
        return (
            <div className="wrapper-search-box">
                {/* <h1 className="name-element-search-box">Search Box</h1> */}
                <div className="container-for-search-control-realloss">
                    {/* <input className="input-seach-box-realloss"
                        placeholder='ID DMA'
                        // value={this.state.dmaID}
                        value={this.props.searchDMA}
                        // onChange={e => { this.setState({ dmaID: e.target.value }) }}
                        onChange={e => { this.props.storeSearchDMA(e.target.value) }}
                    /> */}

                    <Select
                        value={this.props.searchDMA ? { value: this.props.searchDMA, label: this.props.searchDMA } : null}
                        onChange={this.handleChange}
                        options={options}
                        // onInputChange={this.handleInputChange}
                        className="react-select-container-realloss-search"
                        classNamePrefix="react-select-realloss-search"
                        placeholder="DMA ID"
                        isClearable='true'
                    />

                    <DatePicker
                        onChange={this.onChange}
                        // value={this.state.dateSearch}
                        value={new Date(this.props.searchYear, toNumber(this.props.searchMonth) - 1, 1)}
                        className="container-date-picker-component"
                        maxDetail="year"
                    />
                    <button className="pipeline-button-search" onClick={this.searchNow}>
                        <p className="pipeline-button-search-text-inside">Search now</p>
                    </button>
                </div>
            </div>
        )
    }
}

// export default WrapperSearchBoxWBL

const mapStateToProps = state => ({
    listDMAForSelect: get(state, 'GeneralStore.listDMAForSelect'),
    searchMonth: get(state, 'GeneralStore.searchMonth'),
    searchYear: get(state, 'GeneralStore.searchYear'),
    searchDMA: get(state, 'GeneralStore.searchDMA'),
})

const mapDispatchToProps = dispatch => {
    return {
        storeListDMAForSelect: listDMAForSelect => {
            dispatch(storeListDMAForSelect(listDMAForSelect))
        },
        storeSearchMonth: searchMonth => {
            dispatch(storeSearchMonth(searchMonth))
        },
        storeSearchYear: searchYear => {
            dispatch(storeSearchYear(searchYear))
        },
        storeSearchDMA: searchDMA => {
            dispatch(storeSearchDMA(searchDMA))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WrapperSearchBoxWBL)
